import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import { forwardRef } from "react";
import * as t from "@rekajs/types";
import type { ComponentType } from "@repo/editor/types";
import { cn } from "../libs/utils";

export const SpaceDefinition: ComponentSettingsProps = {
  size: {
    label: "اندازه",
    type: "enum",
    options: [
      {
        value: "xs",
        label: "xs",
      },
      {
        value: "sm",
        label: "sm",
      },
      {
        value: "md",
        label: "md",
      },
      {
        value: "lg",
        label: "lg",
      },
      {
        value: "xl",
        label: "xl",
      },
      {
        value: "2xl",
        label: "2xl",
      },
    ],
    default: "md",
  },
};

export interface SpaceProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
}

export const Space = forwardRef<HTMLDivElement, SpaceProps>((props, ref) => {
  const sizes = {
    xs: "py-2 md:py-4 lg:py-8",
    sm: "py-3 md:py-6 lg:py-14",
    md: "py-5 md:py-10 lg:py-20",
    lg: "py-9 md:py-14 lg:py-24",
    xl: "py-12 md:py-20 lg:py-28",
    "2xl": "py-16 md:py-24 lg:py-32",
  };

  const className = sizes[props.size || "md"];

  return <div className={cn("w-full", className)} ref={ref} />;
}) as ComponentType<SpaceProps>;

Space.displayName = "Space";

export const SpaceSettings: ComponentSettings = {
  name: "ESpace",
  props: SpaceDefinition,
  label: "فاصله",
  widgets: {
    label: "فاصله",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "ESpace", external: true }),
      }),
  },
};

Space.componentSettings = SpaceSettings;
